import axios from "axios";

export const showAllWarehousesApi = async(setAllWarehouses) => {
    try {
        const sendRequest = await axios.get(`http://88.222.214.93:5000/service-team/show-warehouses`);
        setAllWarehouses(sendRequest?.data?.allWarehouses);
    } catch (error) {
        console.log(error);
    }
}